/** Map admin notifications to existing AdminDashboard ?tab= routes. No new routes. */

const SOURCE_TAB = {
  delete_request: { tab: "delete-requests", param: "request" },
    consultation: { tab: "field-consultation", param: "consult" },
    consultation_edit_request: { tab: "field-consultation", param: "consult" },
  quote: { tab: "quotes", param: "quote" },
  tech_review_request: { tab: "quotes", param: "quote" },
  contract: { tab: "contracts", param: "contract" },
};

function parseLink(link) {
  if (!link || typeof link !== "string") return { tab: null, id: null };
  try {
    const u = new URL(link, "http://local.invalid");
    const tab = u.searchParams.get("tab");
    const id = u.searchParams.get("request")
      || u.searchParams.get("consult")
      || u.searchParams.get("quote")
      || u.searchParams.get("contract")
      || u.searchParams.get("inquiry");
    return { tab, id };
  } catch {
    return { tab: null, id: null };
  }
}

export function resolveAdminNotificationTarget(n) {
  if (!n) return { tab: null, id: null, param: null };
  if (n.target_tab) {
    const mapped = Object.values(SOURCE_TAB).find((row) => row.tab === n.target_tab);
    return { tab: n.target_tab, id: n.target_id || n.source_id || null, param: mapped?.param || null };
  }
  const source = n.source_type;
  if (source === "consultation_edit_request") {
    const fromLink = parseLink(n.link);
    return { tab: "field-consultation", id: fromLink.id || n.target_id || null, param: "consult" };
  }
  if (SOURCE_TAB[source]) {
    return { tab: SOURCE_TAB[source].tab, id: n.source_id || null, param: SOURCE_TAB[source].param };
  }
  const cat = n.action_type || n.category || "";
  if (cat === "delete_approval" || cat === "delete_request_result") {
    return { tab: "delete-requests", id: n.source_id || null, param: "request" };
  }
  if (cat === "consultation_review" || cat === "consultation_edit_approval" || cat === "consultation_edit_result") {
    return { tab: "field-consultation", id: n.source_id || null, param: "consult" };
  }
  if (cat === "owner_quote_approval" || cat === "quote" || cat === "quote_action" || cat === "tech_review_request") {
    return { tab: "quotes", id: n.source_id || n.target_id || null, param: "quote" };
  }
  if (cat === "inquiry") {
    return { tab: "inquiries", id: n.inquiry_id || n.source_id || null, param: null };
  }
  if (cat === "contract" || cat === "contract_action") {
    return { tab: "contracts", id: n.source_id || null, param: "contract" };
  }
  const fromLink = parseLink(n.link);
  if (fromLink.tab) {
    const mapped = Object.values(SOURCE_TAB).find((row) => row.tab === fromLink.tab);
    return { tab: fromLink.tab, id: fromLink.id, param: mapped?.param || null };
  }
  return { tab: null, id: null, param: null };
}

export function adminNotificationHref(n) {
  const t = resolveAdminNotificationTarget(n);
  if (!t.tab) return n?.link || "/admin";
  const params = new URLSearchParams({ tab: t.tab });
  if (t.param && t.id) params.set(t.param, t.id);
  return `/admin?${params.toString()}`;
}
